import FileSaver from 'file-saver'
import Axios from 'axios'

const fileSaver = (blob, fileName) => {
	const downloadableBlob = new Blob([String.fromCharCode(0xfeff), blob], {
		type: blob.type + ';charset=UTF-8'
	})
	return FileSaver.saveAs(downloadableBlob, fileName)
}

export const downloadFromURL = (URL, fileName) => {
	return Axios.get(URL, {
		responseType: 'blob'
	}).then(({ data: blob }) => {
		fileSaver(blob, fileName)
	})
}

export default fileSaver
